import React from 'react';
import { Form, Input, Button, Card, Space, Layout, message } from 'antd';
import { useNavigate } from 'react-router';
import { userApi } from '../api/user';
import { RegisterRequest } from '../api/user';
import { getPasswordHash } from '../util/crypto';

interface RegisterFormValues {
  name: string;
  phone_number: string;
  username: string;
  password: string;
}

const { Header, Content, Footer } = Layout;

const Register: React.FC = () => {
  const [loading, setLoading] = React.useState(false);
  const navigate = useNavigate();

  const onFinish = async (values: RegisterFormValues) => {
    setLoading(true);
    try {
      // 密码字段处理，API期望password_hash
      const passwordHash = await getPasswordHash(values.password);
      const registerData: RegisterRequest = {
        name: values.name,
        phone_number: values.phone_number,
        username: values.username,
        password_hash: passwordHash,
        user_type: 'doctor' // 默认注册为医生类型
      };

      const response = await userApi.register(registerData);
      if (response.success) {
        message.success('注册成功，请登录');
        navigate('/login');
      } else {
        message.error(response.message || '注册失败，请稍后重试');
      }
    } catch (error) {
      console.error('Register error:', error);
      message.error('网络错误，请稍后重试');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout className="layout" style={{ minHeight: '100vh' }}>
      <Header style={{ background: '#fff', textAlign: 'center', padding: 0 }}>
        <h1>医生管理系统</h1>
      </Header>
      <Content style={{ padding: '0 50px' }}>
        <div style={{ 
          background: '#fff', 
          padding: 24, 
          marginTop: 24, 
          minHeight: 280, 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center' 
        }}>
          <Card title="医生注册" style={{ width: 400 }}>
            <Form<RegisterFormValues>
              name="register"
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 16 }}
              onFinish={onFinish}
              autoComplete="off"
            >
              <Form.Item
                label="姓名"
                name="name"
                rules={[{ required: true, message: '请输入您的姓名!' }]}
              >
                <Input />
              </Form.Item>

              <Form.Item
                label="手机号"
                name="phone_number"
                rules={[
                  { required: true, message: '请输入手机号!' },
                  { pattern: /^1[3-9]\d{9}$/, message: '请输入有效的手机号!' }
                ]}
              >
                <Input />
              </Form.Item>

              <Form.Item
                label="用户名"
                name="username"
                rules={[{ required: true, message: '请设置用户名!' }]}
              >
                <Input />
              </Form.Item>

              <Form.Item
                label="密码"
                name="password"
                rules={[
                  { required: true, message: '请设置密码!' },
                  { min: 6, message: '密码长度不能少于6位!' }
                ]}
              >
                <Input.Password />
              </Form.Item>

              <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
                <Space>
                  <Button type="primary" htmlType="submit" loading={loading}>
                    注册
                  </Button>
                  <Button type="link" onClick={() => navigate('/login')}>
                    已有账号？登录
                  </Button>
                </Space>
              </Form.Item>
            </Form>
          </Card>
        </div>
      </Content>
      <Footer style={{ textAlign: 'center' }}>医生管理系统 ©{new Date().getFullYear()}</Footer>
    </Layout>
  );
};

export default Register;